import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "cases-details" } },
    _vm._l(_vm.casesDeatils, function (caseDetails, index) {
      return _c(
        "div",
        {
          key: `case-${index}-${caseDetails.id}`,
          ref: "casesDetailsRef",
          refInFor: true,
          class: { "mt-8": index !== 0 },
          attrs: {
            "data-qa": "cases-details_case-details",
            "data-popup-content": _setup.genDataPopupContent(caseDetails),
          },
        },
        [
          index !== 0
            ? _c(
                "div",
                [
                  _c(VDivider, {
                    staticClass: "mb-4",
                    attrs: { "data-qa": "cases-details_case-details_divider" },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.xSpaceClass },
            [
              _c("div", { staticClass: "d-flex align-center mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "text-subtitle-1 text--text mr-auto",
                    attrs: { "data-qa": "cases-details_case-details_title" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("Случай", { ns: _vm.$i18next.language })
                        ) +
                        " " +
                        _vm._s(index + 1) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("img", {
                  staticClass: "ma-2 ml-4 opacity-50",
                  attrs: {
                    "data-qa": "cases-details_case-details_logo",
                    src: "/static/_v1/pd/logos/ui-kit/prodoctorov-logo.svg",
                    height: "12",
                    width: "79",
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "d-flex mb-4",
                  class: { "flex-column": _setup.isMobile },
                },
                [
                  caseDetails.lpu
                    ? _c(
                        "div",
                        {
                          staticClass: "d-flex align-center",
                          class: _setup.isMobile
                            ? "mb-2"
                            : "mr-10 flex-basis-50",
                          attrs: {
                            "data-qa": "cases-details_case-details_lpu",
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "ui-icon-place ui-icon-fz-medium icon-secondary--text mr-2",
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-body-2 primary--text cursor-pointer link-decoration-none",
                              attrs: {
                                "data-qa":
                                  "cases-details_case-details_lpu_link",
                                href: caseDetails.lpu.link,
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _setup.transDynamic(
                                    caseDetails.lpu,
                                    `name,${_setup.currentLanguageIso},${_setup.needTranslate}`
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex align-center",
                      class: { "flex-basis-50": !_setup.isMobile },
                      attrs: { "data-qa": "cases-details_case-details_doctor" },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-doctor ui-icon-fz-medium icon-secondary--text mr-2",
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "text-body-2 primary--text cursor-pointer link-decoration-none",
                          attrs: {
                            "data-qa": "cases-details_case-details_doctor_link",
                            href: _vm.doctor.link,
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _setup.transDynamic(
                                _vm.doctor,
                                `fio,${_setup.currentLanguageIso},${_setup.needTranslate}`
                              )
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _setup.isMobile
                ? _c(_setup.CaseImagesSlider, {
                    staticClass: "mb-6 mx-n4 px-4",
                    class: {
                      "case-images-slider": caseDetails.images.length > 1,
                    },
                    attrs: { "case-images": caseDetails.images },
                  })
                : _c(_setup.CaseImages, {
                    staticClass: "mb-6",
                    attrs: { "case-images": caseDetails.images },
                  }),
              _vm._v(" "),
              caseDetails.description
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-1 text--text text-break mb-4",
                      attrs: {
                        "data-qa": "cases-details_case-details_description",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _setup.transDynamic(
                              caseDetails,
                              `description,${_setup.currentLanguageIso},${_setup.needTranslate}`
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mb-4" }, [
                _c(
                  "div",
                  { staticClass: "text-body-2 text-secondary--text mb-1" },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("Стоимость выполнения аналогичных услуг", {
                            ns: _vm.$i18next.language,
                          })
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-subtitle-1 text--text mb-1",
                    attrs: {
                      "data-qa": "cases-details_case-details_total_price",
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("от", { ns: _vm.$i18next.language })) +
                        " " +
                        _vm._s(
                          _setup.getFormattedPrice(caseDetails.total_price)
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "text-body-2 primary--text cursor-pointer",
                    attrs: {
                      "data-qa": "cases-details_case-details_services_btn",
                    },
                    on: {
                      click: function ($event) {
                        return _setup.emit(
                          "click-services-details",
                          caseDetails
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("Что входит в стоимость", {
                            ns: _vm.$i18next.language,
                          })
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _setup.checkAppointmentBtn(caseDetails.lpu)
                ? _c(
                    VBtn,
                    {
                      attrs: {
                        "data-qa": "cases-details_case-details_appointment_btn",
                        color: "primary",
                        block: _setup.isMobile,
                        depressed: "",
                      },
                      on: { click: _setup.emitClickAppointment },
                    },
                    [
                      _c("span", {
                        staticClass: "ui-icon-calendar-date-and-clock mr-2",
                      }),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("Записаться на консультацию", {
                              ns: _vm.$i18next.language,
                            })
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }